// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","separator":"Footer_separator__BhOfx","content":"Footer_content__aJpHx","copyrightYear":"Footer_copyrightYear__Cm189","brand":"Footer_brand__QKAvM"};